import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Tooltip from '../tooltip/Tooltip.vue';
import vuetify from '../../service/useVuetify';
import ButtonCommon from '../buttons/ButtonCommon.vue';

type ClockInformation = {
  timeZone: string
  value: string
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  props: {
    headerTitle: null,
    fullscreenTooltip: { default: '' },
    clockData: null,
    returnArrow: { type: Boolean },
    newNotification: { type: Boolean },
    topBarBreadcrumbs: null
  },
  setup(__props: any) {

const props = __props as { headerTitle?: string, fullscreenTooltip: string, clockData?: ClockInformation, returnArrow?: boolean, newNotification?: boolean, topBarBreadcrumbs?: {
      backEvent: (event: MouseEvent) => void,
      from: string,
      title: string,
      icon?: string,
      iconTooltip?: string,
    } };



const height = computed(() => {
  switch (vuetify.value.breakpoint.name) {
    case "sm":
      return 44;
    case "md":
    case "lg":
      return 56;
    case "xl":
      return 64;
    default:
      return 64;
  }
})

const compressedFont = computed(() => {
  return vuetify.value.breakpoint.name === "sm" || vuetify.value.breakpoint.name === "md";
})

function backClick(event: MouseEvent) {
  if(props.topBarBreadcrumbs) {
    props.topBarBreadcrumbs.backEvent(event);
  }
}

return { __sfc: true,props, height, compressedFont, backClick, Tooltip, ButtonCommon }
}

})